import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CustomWidgetData} from "../../../shared/types/custom-widgets/custom-widget-data";
import {
  OrganizationInformationRestService
} from "../../../shared/services/nso-data-portal/rest-services/organization-information-rest.service";
import {GlobalMessagesService} from "../../../shared/services/messages/global.messages.service";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'wsd-custom-widgets',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './custom-widgets-component.html',
  styleUrls: ['./custom-widgets-component.css']
})
export class CustomWidgetsComponent implements OnInit, OnChanges {

  customWidgets: Observable<CustomWidgetData[]>;

  @Input()
  organizationId: number;

  @Input()
  groupAdminView: boolean;

  constructor(private organizationService: OrganizationInformationRestService,
              private message: GlobalMessagesService,
              private translate: TranslateService,
              private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.loadCustomWidgets();
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  loadCustomWidgets(): void {
    this.customWidgets = this.organizationService.getWidgets(this.organizationId);
    console.log('NDP custom widgets');
    console.log(this.customWidgets);
  }

  sanitizeHtml(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
